import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'

export interface IAloPositionRemarquableConstParam extends IAloDbBaseConstParam {
    prmId:number|null
    ensId:number|null
    prmLibelle:string|null
    gpsLat:number|null
    gpsLon:number|null
  }

export class AloPositionRemarquable extends AloDbBase {
        
    public prmId:number|null
    public ensId:number|null
    public prmLibelle:string|null
    public gpsLat:number|null
    public gpsLon:number|null
    
    constructor({prmId,ensId,prmLibelle,gpsLat,gpsLon,...args }:IAloPositionRemarquableConstParam = {} as IAloPositionRemarquableConstParam) {
        super(args)
        this.prmId = prmId
        this.ensId = ensId
        this.prmLibelle = prmLibelle
        this.gpsLat = gpsLat?gpsLat:0
        this.gpsLon = gpsLon?gpsLon:0
    }

    static createAloPositionRemarquableArray(datas:any) {
        return new AloBaseArray(AloPositionRemarquable,datas)
    }

    static createAloPositionRemarquableWithDetail(data:any) {
        return new AloPositionRemarquable({...data,detailLoaded:true})
    }
}
